const { numericComparator } = require('./utils/comparators');

module.exports = numericComparator((param, value) => param > value);